module.exports = "<layout #layout></layout>\r\n<alerta #alerta></alerta>\r\n<notificacao #notificacao></notificacao>\r\n<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1